// extracted by mini-css-extract-plugin
export default {"footerBg":"g-z","footerTopLinks":"h-z","footerFeedback":"i-z","footerSocial":"j-z","footerLegalLinks":"k-z","footerIconCards":"l-z","footerBotCopy":"m-z"};